export const SHAPE_POSITIONS = {
  FILL: 'Fill',
  RIGHT: 'Right',
  LEFT: 'Left',
  TOP: 'Top',
  BOTTOM: 'Bottom',
};

export const MAX_PHONE_BG_SIZE = 37;
